module.exports = __webpack_public_path__ + "img/Icon_Bin.c4c3159a.svg";